export const journeySteps = [
  {
    number: "01",
    title: "Brief Received",
    description:
      "You tell us who the gift is for, the occasion, the budget — and any little stories that make them, them.",
  },
  {
    number: "02",
    title: "Ideation",
    description:
      "We spend time meticulously crafting a selection of ideas tailored to the occasion and the individual. Each idea is thoughtfully considered.",
  },
  {
    number: "03",
    title: "You Choose",
    description:
      "You pick the idea that resonates most. That single choice sets the entire creation into motion.",
  },
  {
    number: "04",
    title: "Conceptualisation",
    description:
      "We bring the idea to life — moodboards, colour palettes, materials, story arcs, every detail considered.",
  },
  {
    number: "05",
    title: "Personalisation",
    description:
      "Custom labels, hand-written notes, bespoke prints, signature touches. The little details that turn a gift into a memory.",
  },
  {
    number: "06",
    title: "Execution",
    description:
      "Sourced, styled, wrapped and finished by hand. Each layer with care and intention.",
  },
  {
    number: "07",
    title: "Delivered",
    description:
      "A gift becomes a moment. A moment becomes a memory. Wrapped with love — ready to be unwrapped.",
  },
];

export default journeySteps;
